import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Box from '@mui/material/Box'
import No from '../../../../../Assets/Images/Login/no.svg'
import check from '../../../../../Assets/Images/Login/check.png'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import styles from './styles.module.css'

export const AlertModal = ({ show, label, onClick, isError = false }) => {
  return (
    <Modal show={show} centered data-testid="alert-modal">
      <Box className="modal-box">
        <div className="generic-closing-button modal-client">
          <img
            src={No}
            onClick={onClick}
            alt="close"
            data-testid="close-modal"
          />
        </div>
        <div className="modal-content-text">
          {isError ? (
            <ExclamationTriangleFill
              style={{
                fontSize: '40px',
                color: '#FF2A40',
                marginBottom: '19px',
              }}
            />
          ) : (
            <img src={check} alt="check" className={styles.modalCheckImage} />
          )}
          <h2 data-testid="modal-label">{label}</h2>
        </div>
      </Box>
    </Modal>
  )
}
